import { Box, Step, StepLabel, Stepper } from '@mui/material'
import type { JSX } from 'react'
import { useCallback, useMemo, useReducer, useState } from 'react'
import { useTranslation } from 'react-i18next'

import PutIntoServiceStep from '@/pages/intake/PutIntoServiceStep'
import {
  initialSelectedDevicesState,
  SelectedDevicesContext,
  selectedDevicesReducer,
} from '@/pages/intake/reducers'
import { layoutStyles } from '@/utils/theme'

import SelectDevicesForIntakeStep from './SelectDevicesForIntakeStep'

export const IntakePage = (): JSX.Element => {
  const { t } = useTranslation(['app'])
  const [activeStep, setActiveStep] = useState(0)
  const [selectedDevicesState, selectedDevicesDispatch] = useReducer(
    selectedDevicesReducer,
    initialSelectedDevicesState,
  )

  const selectedDevicesContextValue = useMemo(
    () => ({
      state: selectedDevicesState,
      dispatch: selectedDevicesDispatch,
    }),
    [selectedDevicesState, selectedDevicesDispatch],
  )
  const stepLabels = useMemo(
    () => [
      { name: t('app:device.intake.selectDevices') },
      { name: t('app:device.intake.putIntoService') },
    ],
    [t],
  )
  const handleStepChange = useCallback((step: number) => {
    setActiveStep(step)
  }, [])

  return (
    <SelectedDevicesContext.Provider value={selectedDevicesContextValue}>
      <Box
        sx={{
          ...layoutStyles.pageContainer,
          mt: 0,
          p: 3,
        }}
        id={'page container box for intake '}
      >
        <Box sx={{ width: '100%' }} id={'select devices to put into service'}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {stepLabels.map((label) => (
              <Step key={label.name}>
                <StepLabel>{label.name}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 4, position: 'relative', overflow: 'hidden' }}>
            <Box
              sx={{
                transform: `translateX(-${activeStep * 100}%)`,
                transition: 'transform 0.3s ease-in-out',
                display: 'flex',
              }}
            >
              <Box sx={{ width: '100%', flexShrink: 0 }}>
                <SelectDevicesForIntakeStep setActiveStep={handleStepChange} />
              </Box>

              <Box sx={{ width: '100%', flexShrink: 0 }}>
                <PutIntoServiceStep setActiveStep={handleStepChange} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </SelectedDevicesContext.Provider>
  )
}
export default IntakePage
